import { NO_RATING_VALUE } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/constants'
import formatRatingScore from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/functions/formatRatingScore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

/**
 * Текст значения метрики: «+1.7» / «-0.5» / «Нет оценок».
 */
export default function formatRatingStatValue(value: number | null): string {
  if (value === null || value === NO_RATING_VALUE) {
    return tStatic('Нет оценок')
  }

  const formatted = formatRatingScore(value)

  return value > 0 ? `+${formatted}` : formatted
}
